import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faPen, faTrashAlt } from '@fortawesome/free-solid-svg-icons'

library.add(faPen, faTrashAlt)

@Component
export default class Actions extends Vue {
	@Prop() item
	@Prop() onEdit
	@Prop() onDelete

	editEntry(item) {
		typeof this.onEdit === 'function' && this.onEdit(item)
	}

	deleteEntry(item) {
		typeof this.onDelete === 'function' && this.onDelete(item)
	}
}
